<template>
  <div
    class="rounded-full bg-blue-100 text-blue-700 flex items-center justify-center overflow-hidden shrink-0 font-semibold"
    :class="sizeClass"
    :title="name"
  >
    <img
      v-if="showImage"
      :src="src"
      :alt="name"
      class="h-full w-full object-cover"
      loading="lazy"
      @error="failed = true"
    />
    <span v-else>{{ initials }}</span>
  </div>
</template>

<script>
export default {
  name: 'PeerAvatar',
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  data() {
    return {
      failed: false
    };
  },
  computed: {
    src() {
      return this.user?.profilePicture || '';
    },
    name() {
      return this.user?.name || this.user?.displayName || 'Student';
    },
    showImage() {
      return Boolean(this.src) && !this.failed;
    },
    initials() {
      return this.name
        .split(' ')
        .filter(Boolean)
        .map(part => part[0])
        .join('')
        .slice(0, 2)
        .toUpperCase() || 'S';
    },
    sizeClass() {
      const sizes = {
        sm: 'h-10 w-10 text-sm',
        md: 'h-12 w-12 text-base',
        lg: 'h-16 w-16 text-xl',
        xl: 'h-24 w-24 text-3xl'
      };
      return sizes[this.size] || sizes.md;
    }
  },
  watch: {
    src() {
      this.failed = false;
    }
  }
};
</script>
